import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { Office } from 'src/app/Models/office';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-offices',
  templateUrl: './offices.component.html',
  styleUrls: ['./offices.component.css']
})
export class OfficesComponent implements OnInit {

  formTitle = "Manage Departments";
  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  dataList = [];
  loadingRecords = true;
  sortValue: string = "desc";
  sortKey: string = "id";
  searchText: string = "";
  filterQuery: string = "";
  isFilterApplied: string = "default";
   logtext:string = "";

  columns: string[][] =[ ["NAME","Name"],["POST","Email Id"],["DEPARTMENT","Department"],["MOBILE_NUMBER","Mobile Number"],["SEQUENCE_NO","Sequence Number"]]

  //drawer Variables
  drawerVisible: boolean;
  drawerTitle: string;
  drawerData: Office = new Office();
  constructor(private api: ApiService,private message: NzNotificationService) { }
  ngOnInit() {
    this.search();

	this.logtext = 'OPENED - Office form KEYWORD[O - Office] ';
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
          });
  }
  // Basic Methods
  sort(sort: { key: string; value: string }): void {
    this.sortKey = sort.key;
    this.sortValue = sort.value;
    this.search(true);

  }
  search(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }
    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
	
	this.logtext = 'Filter Applied - Office form"+ sort +" "+this.sortKey +" KEYWORD [F - Office] ';
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
      });

    } catch (error) {
      sort = "";
    }
    console.log("search text:" + this.searchText);
    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)
      console.log("likeQuery" + likeQuery);
    }

	this.logtext = 'Filter Applied - Office form "+ likeQuery +" KEYWORD [F - Office] ';
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
      });

    this.api.getAllOffice(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery).subscribe(data => {
      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.dataList = data['data'];
    }, err => {
      console.log(err);
    });
  }
  //Drawer Methods
  get closeCallback() {
    return this.drawerClose.bind(this);
  }
  add(): void {
    this.drawerTitle = "Create New Department";
    this.drawerData = new  Office();
    this.drawerVisible = true;

	this.logtext = 'ADD - Office form KEYWORD [A - Office] ';
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
      });

  }
  edit(data:  Office): void {

    this.drawerTitle = "Update Department";
    this.drawerData = Object.assign({}, data);
    this.drawerVisible = true;

	this.logtext = 'EDIT - Office form KEYWORD [E - Office] ';
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
          });


  }
  drawerClose(): void {
    this.search();
    this.drawerVisible = false;
  }

  
  publish(): void {

    this.api.publish('office')
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.message.success("Page Published Successfully", "");
          window.open("http://krishnakoyanapatsanstha.com/departments.html", "_blank");
        }
        else {
          this.message.error("Failed to publish...", "");
        }
      });

  }


  preview(): void {

    this.api.preview('office')
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.message.success("Page Published Successfully", "");
          window.open("http://krishnakoyanapatsanstha.com/preview/departments.html", "_blank");
        }
        else {
          this.message.error("Failed to publish...", "");
        }
      });

  }
}